import React from 'react';
import last from 'lodash/last';

import { useFormState } from 'react-final-form';

import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';

import { SyncMeetingsSteps } from '../../types';

type Props = {
  steps: Array<SyncMeetingsSteps>;
  currentStep: SyncMeetingsSteps;
  onSubmit(): void;
  onNextStep(): void;
  onBackClick(): void;
};

function getPrimaryButtonText({ currentStep, isLastStep, selectedEmail }) {
  switch (currentStep) {
    case SyncMeetingsSteps.inviteTeammates: {
      if (!isLastStep) return 'Next';
      if (selectedEmail) return 'Invite';
      return 'Finish';
    }
    default:
      return 'Next';
  }
}

function ButtonsArea({ onSubmit, onBackClick, onNextStep, currentStep, steps }: Props) {
  const {
    submitting,
    errors,
    values: { inviteeEmails },
  } = useFormState();

  const selectedEmail = inviteeEmails.some(({ selected }) => selected);
  const isLastStep = currentStep === last(steps);
  const showBackButton = currentStep !== steps[0];
  const primaryButtonText = getPrimaryButtonText({
    currentStep,
    isLastStep,
    selectedEmail,
  });

  const errorsExist = !!Object.keys(errors).filter(key => errors[key]).length;

  return (
    <WpButtonGroup>
      {!isLastStep && (
        <WpButton variant="tertiary" qaTest="sync-meetings-skip-button" disabled={submitting} onClick={onNextStep}>
          Skip
        </WpButton>
      )}
      {showBackButton && (
        <WpButton variant="secondary" qaTest="sync-meetings-back-button" disabled={submitting} onClick={onBackClick}>
          Back
        </WpButton>
      )}
      <WpButton
        btnType="submit"
        qaTest="sync-meetings-submit-button"
        loading={submitting}
        disabled={errorsExist}
        onClick={onSubmit}
      >
        {primaryButtonText}
      </WpButton>
    </WpButtonGroup>
  );
}

export default ButtonsArea;
